{
  "ChartprovideroptionsHighcharts": "Hohe Charts",
  "ChartprovideroptionsAmcharts": "AM-Charts",
  "NAME": "ChartProviderOptions"
}